<template>
    <v-card
        width="100%"
        height="50px"
        color="#FAFAFD"
        elevation="0"
        class="my-2"
        v-if="appear.show"
    >
        <v-card-text>
            <v-row align="center">
                <v-col
                    cols="1"
                    md="1"
                    class="pa-0 pt-1"
                    v-if="appear.color == 'orange'"
                >
                    <v-btn
                        color="#F1996D"
                        dark
                        min-width="34"
                        height="34"
                        min-height="34"
                        class="pa-0"
                        style="border-radius: 6px"
                    >
                        <v-icon style="transform: rotate(-90deg)"
                            >mdi-attachment</v-icon
                        >
                    </v-btn>
                </v-col>
                <v-col
                    cols="1"
                    md="1"
                    class="pa-0 pt-1"
                    v-if="appear.color == 'red'"
                >
                    <v-btn
                        color="#FF544A"
                        dark
                        min-width="34"
                        height="34"
                        min-height="34"
                        class="pa-0"
                        style="border-radius: 6px"
                    >
                        <v-icon style="transform: rotate(-90deg)"
                            >mdi-attachment</v-icon
                        >
                    </v-btn>
                </v-col>
                <v-col
                    cols="10"
                    md="10"
                    class="pa-0 pt-1"
                    v-if="appear.color == 'orange'"
                >
                    {{ appear.fileName }}
                </v-col>
                <v-col
                    cols="10"
                    md="10"
                    class="pa-0 pt-1"
                    v-if="appear.color == 'red'"
                >
                    <div style="color: #ff544a">{{ $t(`${appear.fileName}`) }}</div>
                </v-col>
                <v-col cols="1" md="1" class="pa-0" v-if="false">
                    <v-btn icon
                        ><v-icon small color="#9D9B9A"
                            >mdi-download</v-icon
                        ></v-btn
                    >
                </v-col>
                <v-col cols="1" md="1" class="pa-0 pl-2 pr-0">
                    <v-btn icon @click="deleteFile"
                        ><v-icon small color="#9D9B9A"
                            >mdi-delete</v-icon
                        ></v-btn
                    >
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "FileInput",
    data: () => ({}),
    props: {
        appear: Object,
    },
    methods: {
        deleteFile() {
            this.$emit("deleteFile", false, this.appear);
        },
    },
};
</script>
